import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Banner from "./Banner/Banner";
import Breadcrumbs_Holder from "../../Common_Component/Breadcrumbs_Holder/Breadcrumbs_Holder";
import Benifits from "../../Common_Component/Benifits/Benifits";
import Branding_Why_Choose_Us from "./Branding_Why_Choose_Us/Branding_Why_Choose_Us";
import Branding_How_it_Works from "./Branding_How_it_Works/Branding_How_it_Works";
import Branding_Title_Component from "./Branding_Title_Component/Branding_Title_Component";
import Get_In_Touch from "../All_services_inner/Video_Wala_Bus_Stand/Video_Wala_Bus_Stand_inner_content/Get_In_Touch/Get_In_Touch";
import Branding_Benifits from "./Branding_Benifits/Branding_Benifits";
import Our_Services from "./Our_Services/Our_Services";

const Branding_Inner_Service = (props) => {
  const [data, setData] = useState();
  const { id } = useParams();

  const get_in_touch = [
    {
      id: 1,
      imgSrc: "/Assets/Images/Banners/LOGO_Designing/Logo_designing.png",
      getInTouch_Title: "Ready to craft a  ",
      getInTouch_Titl2: "logo that defines your brand? ",
      getInTouch_Descn:
        "Let’s bring your vision to life with a design that resonates. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/printMedia.png",
      vidowala: false,
    },

    {
      id: 2,
      imgSrc: "/Assets/Images/Banners/Graphic/GraphicDesigning.png",
      getInTouch_Title: "Ready to transform your ",
      getInTouch_Titl2: "ideas into stunning visuals? ",
      getInTouch_Descn:
        "Let’s create designs that captivate and inspire. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/printMedia.png",
      vidowala: false,
    },

    {
      id: 3,
      imgSrc: "/Assets/Images/Banners/Brand/BRANDING.png",
      getInTouch_Title: "Ready to create a brand  ",
      getInTouch_Titl2: "that leaves a lasting impression?",
      getInTouch_Descn:
        " Let’s design a visual identity that tells your story. Contact us today to get started!",
      getInTouch_Img:
        "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/printMedia.png",
      vidowala: false,
    },
  ];

  useEffect(() => {
    const filteredArray = get_in_touch.find((item) => item.id === Number(id));
    setData(filteredArray || {});
  }, [id]);

  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: "Branding", link: "/services-inner/5", active: false },
    { label: "LOGO Designing", link: "", active: true }, // Default title
  ]);

  // Update breadcrumb dynamically
  const updateBreadcrumb = (title) => {
    setBreadcrumbs([
      { label: "Branding", link: "/services-inner/5", active: false },
      { label: title, link: "", active: true },
    ]);
  };

  return (
    <section className="Branding_Inner_Service">
      <Banner imgSrc={data?.imgSrc} />
      <Breadcrumbs_Holder breadcrumbs={breadcrumbs} />
      <Branding_Title_Component updateBreadcrumb={updateBreadcrumb} />
      <Branding_How_it_Works />
      <Branding_Benifits />
      <Branding_Why_Choose_Us />

      {/* Conditionally render Our_Services based on id */}
      {(id === "2" || id === "3") && <Our_Services />}

      <Get_In_Touch
        vidowala={data?.vidowala != undefined ? data?.vidowala : true}
        getInTouch_Img={data?.getInTouch_Img}
        getInTouch_Title={data?.getInTouch_Title}
        getInTouch_Titl2={data?.getInTouch_Titl2}
        getInTouch_Descn={data?.getInTouch_Descn}
      />
    </section>
  );
};

export default Branding_Inner_Service;
